var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateTrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75,174c0-21.1,6.5-40.6,17.7-56.7c-0.9,0.1-1.8,0.1-2.7,0.1c-20.4,0-37-16.6-37-37c0-20.4,16.6-37,37-37 s37,16.6,37,37c0,2.1-0.2,4.2-0.5,6.2c11.2-6.2,23.7-10.3,36.9-11.9C158.8,38.2,127.7,10,90,10c-40.9,0-74,33.1-74,74 s74,162.8,74,162.8s2.5-4,6.5-10.9C83,218.9,75,197.4,75,174z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.5,126.7c-3.8-4.6-8-9-12.8-12.7c-4.8-3.8-9.8-6.8-15.3-9.3c-1-0.4-2-0.9-2.9-1.3 c-8.7-3.5-18.1-5.5-28.1-5.5H174c-41.3,0-74.9,33.5-74.9,74.9v1.3c0,41.3,33.5,74.9,74.9,74.9h1.3c41.3,0,74.9-33.5,74.9-74.9v-1.3 C250.2,155.4,244.3,139.4,234.5,126.7z M232.2,183.9h-45v45h-21c-0.1,0.1-0.1-45-0.1-45h-45v-21.1h45v-45h21v45h45.1V183.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateTrip);
export default __webpack_public_path__ + "static/media/create-trip.c9ffbafbd7e06513969a2d9f1c973af6.svg";
export { ForwardRef as ReactComponent };